:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._rulers_ls4no_7._horizontalRuler_ls4no_7 {
  position: absolute;
  right: 0;
  top: 0;
  width: 22px;
  height: calc(100% - 22px); }
  ._rulers_ls4no_7._horizontalRuler_ls4no_7._for-sections_ls4no_13 {
    z-index: 4; }
    ._rulers_ls4no_7._horizontalRuler_ls4no_7._for-sections_ls4no_13 ._horizontalTicks_ls4no_15 ._rulersBackground_ls4no_15 {
      overflow: hidden; }
  ._tools-hidden_ls4no_17 ._rulers_ls4no_7._horizontalRuler_ls4no_7 ._horizontalTicks_ls4no_15 {
    width: 0; }
  ._rulers_ls4no_7._horizontalRuler_ls4no_7 ._horizontalTicks_ls4no_15 ._rulersSeparator_ls4no_19 {
    position: absolute;
    width: 22px;
    height: 22px;
    top: 0;
    background-color: #fff;
    transition: opacity 0.15s ease-in;
    transition-delay: 0.15s;
    opacity: 0.5; }
    ._rulers_ls4no_7._horizontalRuler_ls4no_7 ._horizontalTicks_ls4no_15 ._rulersSeparator_ls4no_19._rulersSeparatorHover_ls4no_28 {
      transition: opacity 0.15s ease-out;
      opacity: 0.9;
      cursor: default; }
  ._rulers_ls4no_7._horizontalRuler_ls4no_7 ._horizontalTicks_ls4no_15 ._rulersBackground_ls4no_15 {
    position: absolute;
    top: 22px;
    right: 0; }
    ._rulers_ls4no_7._horizontalRuler_ls4no_7 ._horizontalTicks_ls4no_15 ._rulersBackground_ls4no_15._rulersBackgroundMobile_ls4no_36 {
      top: 0; }
    ._rulers_ls4no_7._horizontalRuler_ls4no_7 ._horizontalTicks_ls4no_15 ._rulersBackground_ls4no_15 ._rulersHorizontalTicks_ls4no_38 {
      background: url(//static.parastorage.com/services/santa-resources/resources/editor/rEditor/rootComps/rulers/ruler_ticks_vertical.png) repeat-y;
      width: 100%;
      height: 100%; }
    ._rulers_ls4no_7._horizontalRuler_ls4no_7 ._horizontalTicks_ls4no_15 ._rulersBackground_ls4no_15 ._rulerNumbersContainer_ls4no_42 {
      position: absolute;
      text-align: left;
      width: 100%;
      height: 100%; }
      ._rulers_ls4no_7._horizontalRuler_ls4no_7 ._horizontalTicks_ls4no_15 ._rulersBackground_ls4no_15 ._rulerNumbersContainer_ls4no_42 ._rulerNumber_ls4no_42 {
        word-break: break-all;
        height: 100px;
        width: 0;
        margin-left: 4px;
        text-align: left; }
  ._rulers_ls4no_7._horizontalRuler_ls4no_7 ._horizontalTicks_ls4no_15:hover {
    cursor: copy; }

._rulers_ls4no_7._verticalRuler_ls4no_56 {
  pointer-events: auto;
  position: absolute;
  right: 22px;
  top: 0;
  height: 22px; }
  ._rulers_ls4no_7._verticalRuler_ls4no_56._for-sections_ls4no_13 {
    right: 0; }
    ._rulers_ls4no_7._verticalRuler_ls4no_56._for-sections_ls4no_13._fixedStage_ls4no_64 {
      z-index: 3; }
  ._rulers_ls4no_7._verticalRuler_ls4no_56 ._verticalTicks_ls4no_66 {
    width: 100%;
    height: 100%; }
    ._rulers_ls4no_7._verticalRuler_ls4no_56 ._verticalTicks_ls4no_66:hover {
      cursor: copy; }
    ._tools-hidden_ls4no_17 ._rulers_ls4no_7._verticalRuler_ls4no_56 ._verticalTicks_ls4no_66 {
      height: 0; }
    ._rulers_ls4no_7._verticalRuler_ls4no_56 ._verticalTicks_ls4no_66 ._rulersSeparatorBlocker_ls4no_73 {
      position: absolute;
      top: 0;
      right: -22px;
      height: 22px;
      width: 22px;
      cursor: default;
      z-index: 160; }
    ._rulers_ls4no_7._verticalRuler_ls4no_56 ._verticalTicks_ls4no_66 ._rulersBackground_ls4no_15 ._rulersVerticalTicks_ls4no_81 {
      background: url(//static.parastorage.com/services/santa-resources/resources/editor/rEditor/rootComps/rulers/ruler_ticks.png) 0 0 repeat-x;
      width: 100%;
      height: 100%; }
    ._rulers_ls4no_7._verticalRuler_ls4no_56 ._verticalTicks_ls4no_66 ._rulersBackground_ls4no_15 ._rulerNumbersContainer_ls4no_42 {
      position: absolute;
      bottom: 2px;
      display: flex; }
      ._rulers_ls4no_7._verticalRuler_ls4no_56 ._verticalTicks_ls4no_66 ._rulersBackground_ls4no_15 ._rulerNumbersContainer_ls4no_42 ._rulerNumber_ls4no_42 {
        display: inline-block;
        width: 100px;
        text-align: left; }

._rulers_ls4no_7 ._rulersBackground_ls4no_15 {
  height: 100%;
  width: 100%;
  background-color: #fff;
  transition: opacity 0.15s ease-in;
  transition-delay: 0.15s;
  opacity: 0.5; }
  ._rulers_ls4no_7 ._rulersBackground_ls4no_15._rulersBackgroundHover_ls4no_101 {
    transition: opacity 0.15s ease-out;
    opacity: 0.9; }
  ._rulers_ls4no_7 ._rulersBackground_ls4no_15 ._rulerNumbersContainer_ls4no_42 {
    color: #384f68;
    font-size: 9px;
    letter-spacing: 1px; }

._rulers_ls4no_7._mobileEditorRulers_ls4no_109._verticalRuler_ls4no_56 {
  top: calc(-1 * var(--g-mobile-top)); }

._rulers_ls4no_7._mobileEditorRulers_ls4no_109 ._horizontalTicks_ls4no_15 {
  top: 0; }
  ._rulers_ls4no_7._mobileEditorRulers_ls4no_109 ._horizontalTicks_ls4no_15 ._rulerNumbersContainer_ls4no_42 {
    top: 0; }

._rulers_ls4no_7 .tooltip-presenter {
  border-radius: 15px;
  height: 30px;
  white-space: nowrap;
  cursor: default; }
  ._rulers_ls4no_7 .tooltip-presenter.hover-bubble {
    height: 24px; }
    ._rulers_ls4no_7 .tooltip-presenter.hover-bubble:hover {
      background-color: #d6e6fe; }
      ._rulers_ls4no_7 .tooltip-presenter.hover-bubble:hover .input-stepper .input {
        background-color: #d6e6fe; }
    ._rulers_ls4no_7 .tooltip-presenter.hover-bubble .input-stepper {
      margin-top: 2px; }
  ._rulers_ls4no_7 .tooltip-presenter .content-wrapper {
    padding: 0; }

._rulersInFixedStage_ls4no_133._verticalRuler_ls4no_56 {
  top: var(--horizontal-ruler-top);
  left: var(--stage-left-margin); }
  ._rulersInFixedStage_ls4no_133._verticalRuler_ls4no_56 ._verticalTicks_ls4no_66 {
    width: var(--stage-fixed-width); }

._rulersInFixedStage_ls4no_133._horizontalRuler_ls4no_7 {
  right: var(--horizontal-ruler-right); }
  ._rulersInFixedStage_ls4no_133._horizontalRuler_ls4no_7 ._horizontalTicks_ls4no_15 ._rulersBackground_ls4no_15 {
    top: 0;
    height: calc(100% + 22px); }
